module.exports = __webpack_public_path__ + "static/GrandStream-71ba16351b3bd403613cb83880b77a89.png";